<template>
  <div class="sa-free-page" style="height: 100%">
    <div class="sa-free-page-header">
      <b-form>
        <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col cols="6">
            <label>Presidio</label>
            <b-form-select v-model="filtroPlanning.idPresidio" :options="presidiOptions" text-field="text" value-field="value" :disabled="true">
              <template #first>
                <b-form-select-option :value="null">- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>

          <b-col cols="6">
            <label>Identificativo</label>
            <b-form-input v-model="filtroPlanning.identificativo" text-field="nome" value-field="nome" placeholder="Inserisci un identificativo"></b-form-input>
          </b-col>
          <b-col cols="4">
            <label>Cognome</label>
            <b-form-input v-model="filtroPlanning.cognome" text-field="nome" value-field="nome" placeholder="Inserisci un cognome"></b-form-input>
          </b-col>
          <b-col cols="4">
            <label>Nome</label>
            <b-form-input v-model="filtroPlanning.nome" text-field="nome" value-field="nome" placeholder="Inserisci un nome"></b-form-input>
          </b-col>
          <b-col cols="4">
            <label>Area</label>
            <b-form-select v-model="filtroPlanning.area" :options="areaOptions" text-field="text" value-field="value">
              <template #first>
                <b-form-select-option :value="null">- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-2" style="margin-left: 0.5rem; margin-right: 0.2rem">
          <b-col class="sa-padding-right text-right">
            <b-button @click="onSubmit()" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
            <b-button @click="onReset()" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div class="sa-planning">
      <div class="sa-planning-header">
        <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Teleconsulto" @click="onClickPreviousDay()">
          <i class="fas fa-chevron-left"></i>
        </b-button>
        <span class="sa-planning-range-label">Dal {{ formatDate(dataDal) }} al {{ formatDate(dataAl) }}</span>
        <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Teleconsulto" @click="onClickNextDay()">
          <i class="fas fa-chevron-right"></i>
        </b-button>
      </div>
      <div class="sa-planning-body">
        <div class="b-table-sticky-header">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="getFields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <!--<template #cell(area)="row">
						<div style="display: none">{{ (slot = getArea(row)) }}</div>
						<div>
							<span style="display: block; font-weight: 700">{{ slot.area }}</span>
							<span style="display: block; font-style: italic">Data Inizio: {{ formatDate(slot.dataInizio) }}</span>
							<span style="display: block; font-style: italic">Data Fine: {{ formatDate(slot.dataFine) }}</span>
						</div>
					</template>-->
            <template #cell()="row">
              <div style="display: none">{{ (slots = getDettaglioAttivita(row)) }}</div>
              <div v-for="slot in slots" :key="slot.id" :class="getClassByStato(slot.stato)">
                <span class="sa-planning-body-activiti-name">{{ slot.nomeAttivita }}</span>
                <div class="sa-planning-meta">
                  <span class="sa-planning-time">Ora: {{ slot.oraProgrammata }}</span>
                  <span class="sa-planning-id d-block">{{ slot.identificativo }}</span>
                  <span class="sa-planning-person d-block">
                    <span class="sa-person-cognome">{{ slot.cognome }} {{ slot.nome }}</span>
                  </span>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="sa-planning-footer"></div>
    </div>
  </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
export default {
  mixins: [UtilityMixin],
  // computed: {
  // 	headers() {
  // 		return ["Attivita", 1, 2, 3, 4, 5, 6];
  // 	},
  // },
  data() {
    return {
      currentPage: 1,
      perPage: 10000000,
      listKey: 0,
      showModalLoading: false,
      dataDal: null,
      dataAl: null,
      pathResource: "/rsaplanning",
      filtroPlanning: { idPresidio: null, identificativo: null, cognome: null, nome: null, dataRiferimento: null, area: null },
      idAccettazione: null,
      idUtente: null,
      idPresidio: null,
      items: [],
      presidiOptions: [],
      areaOptions: [],
    };
  },

  mounted() {
    let me = this;
    me.idAccettazione = me.$route.query.idAccettazione;
    if (me.idAccettazione) {
      me.filtroPlanning.idAccettazione = me.idAccettazione;
    }
    let sessionStorage = window.sessionStorage;
    if (sessionStorage["filtroPlanning"]) {
      me.filtroPlanning = JSON.parse(sessionStorage["filtroPlanning"]);
    }
    if (localStorage.getItem("presidio")) {
      let presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
      me.idPresidio = presidio ? presidio.idPresidio : null;
      me.filtroPlanning.idPresidio = me.idPresidio;
    }
    /*  if (me.filtroPlanning.idPresidio) {
            me.dataRiferimento = me.filtroPlanning.dataRiferimento ? me.filtroPlanning.dataRiferimento : new Date().getTime();
            me.loadData();
        } */
    me.changeRange();
    // if (me.presidiOptions.length === 1) {
    //     me.filtroPlanning.idPresidio = me.presidiOptions[0].value;
    // }
  },
  computed: {
    getFields() {
      let fields = [
        //{
        //	label: "Area",
        //	key: "area",
        //	sortable: true,
        //	//thStyle: "width: 7rem",
        //},
      ];
      let dataInizio = this.dataDal;
      let dataFine = this.dataAl;
      let contatore = 1;
      while (dataInizio <= dataFine) {
        fields.push({
          label: moment(dataInizio).format("ddd DD MMMM"),
          key: "slot" + contatore,
          sortable: false,
          slotDateValue: dataInizio,
          //thStyle: "width: 7rem",
        });
        dataInizio = dataInizio + 86400000;
        contatore++;
      }
      return fields;
    },
  },
  methods: {
    init(idUtente) {
      let me = this;
      me.idUtente = idUtente;
      me.loadArea();
      me.loadPresidi();
    },
    getWeekRowClass(index) {
      if (index === 0) {
        return "sa-planning-week-row sa-planning-week-header";
      } else {
        return "sa-planning-week-row-body";
      }
    },
    getClassByStato(stato) {
      return "sa-stato-" + stato.toLowerCase().replace(" ", "-");
    },
    loadData() {
      let me = this;
      me.$emit("changeShowModalLoading", true);
      let sessionStorage = window.sessionStorage;
      sessionStorage.setItem("filtroPlanning", JSON.stringify(me.filtroPlanning));
      UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroPlanning, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.$emit("changeShowModalLoading", false);
    },
    loadDataError(error) {
      console.log(error);
    },
    //getArea(row) {
    //    let slot = { area: row.item.area, dataInizio: row.item.dataInizio, dataFine: row.item.dataFine };
    //    return slot;
    //},
    getDettaglioAttivita(row) {
      let slot = [];

      row.item.attivitaSchedulate.forEach((element) => {
        let dataSlot = moment(row.field.slotDateValue).format("DD/MM/YYYY");
        let dataAttivita = moment(element.dataOraProgrammata).format("DD/MM/YYYY");

        if (dataSlot === dataAttivita) {
          slot.push({ id: self.crypto.randomUUID(), nomeAttivita: element.nomeAttivita, stato: element.stato, identificativo: element.identificativo, nome: row.item.nome, cognome: row.item.cognome, oraProgrammata: moment(element.dataOraProgrammata).format("HH:mm") });
        }
      });
      return slot;
    },
    onClickPreviousDay() {
      let dataDal = this.dataDal - 86400000;
      this.changeRange(dataDal);
    },
    onClickNextDay() {
      let dataDal = this.dataDal + 86400000;
      this.changeRange(dataDal);
    },
    changeRange(dataDal) {
      this.dataDal = dataDal ? dataDal : new Date().getTime();
      this.dataAl = this.dataDal + 6 * 86400000;
      this.filtroPlanning.dataRiferimento = this.dataDal;
      if (this.filtroPlanning.idPresidio) {
        this.loadData();
      }
    },
    onSubmit() {
      if (!this.filtroPlanning.idPresidio) {
        this.$bvToast.toast("Selezionare un presidio", {
          title: "Attenzione",
          variant: "warning",
          solid: true,
        });
        return;
      }
      this.loadData();
    },
    onReset() {
      this.filtroPlanning = { idPresidio: this.idPresidio, identificativo: null, cognome: null, nome: null, dataRiferimento: this.filtroPlanning.dataRiferimento, area: null };
      if (this.filtroPlanning.idPresidio) {
        this.loadData();
      }
    },
    loadPresidi() {
      let me = this;
      UtilityMixin.methods.loadDataResources("/utentipresidi", { idUtente: me.idUtente }, me.loadPresidiSuccess, me.loadPresidiError);
    },
    loadPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list.map((presidio) => {
        return { value: presidio.idPresidio, text: presidio.denominazionePresidio };
      });
    },
    loadPresidiError(error) {
      console.log(error);
    },
    loadArea() {
      let me = this;
      UtilityMixin.methods.loadDataResources("/rsaaree", me.filtroPlanning, me.loadAreaSuccess, me.loadAreaError);
    },
    loadAreaSuccess(response) {
      let me = this;
      me.areaOptions = response.data.data.list.map((area) => {
        return { value: area.nome, text: area.nome };
      });
    },
    loadAreaError(error) {
      console.log(error);
    },
  },
};
</script>

<style>
.sa-planning-id {
  font-weight: 600;
  display: block;
}
.sa-planning-person {
  display: block;
  white-space: normal;
}
.sa-person-cognome {
  display: block;
  font-weight: 700;
}
</style>
